<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <b-row>
        <b-col cols="12" lg="6" xl="3">
          <search-input
            placeholder="أدخل اسم المنظمة أو جزء منه ..."
            v-model="search.name"
          />
        </b-col>
        <b-col cols="12" lg="6" xl="3">
          <form-select
            placeholder="اختر المحافظات ..."
            ep="v2/ministry/selects/governorates"
            multiple
            :closeOnSelect="false"
            v-model="search.governorates_ids"
            :getOptionLabel="(x) => x.name_ar"
            :reduce="(x) => x.id"
          />
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end my-1">
        <loader-btn
          :loading="exporting"
          variant="warning"
          label="تصدير"
          icon="ArrowDownCircleIcon"
          @click="exportToExcelwithParam({ep : 'v2/ministry/custom/reports/export-ngo-weights', params : search} )"
          size="sm"
        />
      </div>
      
      <data-table
        striped
        ref="validationReportTable"
        :fields="fields"
        ep="v2/ministry/custom/reports/ngo-weights"
      >
        <template #cell(name_ar)="{ item, value }">
          <div class="d-flex align-items-center">
            <b-avatar size="50" variant="light" class="mr-1" :src="item.logo" />
            {{ value }}
          </div>
        </template>
        <template #cell(weightsInfo.mark)="{ value }">
          <span class="text-info h4">{{ value }} %</span>
        </template>
        <template #cell(weightsInfo.completion)="{ value }">
          <span class="text-success h4">{{ value }} %</span>
        </template>
        <template #cell(completed_by_ngo_at)="{ value }">
          <span>{{ value ? $moment(value).format("DD-MM-YYYY") : null }} </span>
        </template>
        <template #cell(completed_by_directorate_at)="{ value }">
          <span>{{ value ? $moment(value).format("DD-MM-YYYY") : null }} </span>
        </template>
        <template #cell(completed_by_ministry_at)="{ value }">
          <span>{{ value ? $moment(value).format("DD-MM-YYYY") : null }} </span>
        </template>
      </data-table>
    </b-card>
  </div>
</template>

<script>
import SearchInput from "@/components/SearchInput.vue";
import FormSelect from "@/components/form-select";
import DataTable from "@/components/data-table";
import MinistryBreadcrumbs from "../../../../components/MinistryBreadcrumbs";
import debounce from "lodash.debounce";
import LoaderBtn from "@/components/loader-btn.vue";
import {
  BCard,
  BRow,
  BCol,
  BProgress,
  BProgressBar,
  BAvatar,
  BButton,
} from "bootstrap-vue";
import { mapActions , mapGetters } from "vuex";
export default {
  components: {
    FormSelect,
    SearchInput,
    DataTable,
    BCard,
    BRow,
    BCol,
    BProgress,
    BProgressBar,
    BAvatar,
    BButton,
    MinistryBreadcrumbs,
    LoaderBtn
  },
  methods: {
    ...mapActions("Ministry/Settings/ShamlForms", ["deleteForm"]),
    ...mapActions("Exporter", ["exportToExcelwithParam"]),
  },
  computed: {
    ...mapGetters("Exporter", ["exporting"]),
  },
  data() {
    return {
      search: {
        name: "",
        governorates_ids: [],
      },
      mainTitle: "تقرير التدقيق",
      breadcrumbs: [
        // {
        //   text: "الإعدادات",
        //   to: "/ministry/settings",
        // },
        {
          text: "إدارة المنظمات",
          to: "/ministry/ngos-communication",
        },
        {
          text: "تقرير التدقيق",
          active: true,
        },
      ],
      fields: [
        {
          key: "id",
          label: " ",
        },
        {
          key: "name_ar",
          label: "اسم المنظمة",
        },
        {
          key: "hq.name",
          label: "محافظة المقر",
        },
        {
          key: "legalForm.name_ar",
          label: "الشكل القانوني",
        },
        {
          key: "weightsInfo.completion",
          label: "اكتمال المعلومات الالزامية",
        },
        {
          key: "weightsInfo.mark",
          label: "اكتمال بيانات المنظمة",
        },
        {
          label: "اعتُمدَ من قبل المنظمة بتاريخ",
          key: "completed_by_ngo_at",
        },
        {
          label: "اعتُمدَ من قبل المديرية بتاريخ",
          key: "completed_by_directorate_at",
        },
        {
          label: "اعتُمدَ من قبل الوزارة بتاريخ",
          key: "completed_by_ministry_at",
        },
        {
          label: "اعتُمدَ من قبل المديرية من قبل",
          key: "completedByDirectorate.full_name",
        },
        {
          key: "completed_by_ngo_name.full_name",
          label: "اعتُمدَ من قبل المنظمة من قبل",
        },
        {
          label: "اعتُمدَ من قبل الوزارة من قبل",
          key: "completedByMinistry.full_name",
        },
      ],
    };
  },
  watch: {
    search: {
      deep: true,
      handler: debounce(function (val) {
        var filter = { ...val };
        if (filter.name.length === 0) delete filter.name;
        if (filter.governorates_ids.length === 0)
          delete filter.governorates_ids;

        this.$refs.validationReportTable.setQueryParams(val);
        this.$refs.validationReportTable.refreshTable();
      }, 500),
    },
  },
};
</script>
